import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import CardLabel from "./CardLabel";
const CardLabelPreview = () => {
    return (_jsx(CardLabel, { title: "Carte label", description: "Description de la Carte label", alignment: "center" }));
};
export default CardLabelPreview;
